<!-- Operation photo status tabs -->
<div class="verif-tabs">
    <button class="verif-tab verif-tab--pending" [class.verif-tab--active]="activeStatus === 'PENDING'"
        (click)="setStatus('PENDING')">Pending</button>
    <button class="verif-tab verif-tab--approved" [class.verif-tab--active]="activeStatus === 'APPROVED'"
        (click)="setStatus('APPROVED')">Approved</button>
    <button class="verif-tab verif-tab--rejected" [class.verif-tab--active]="activeStatus === 'REJECTED'"
        (click)="setStatus('REJECTED')">Rejected</button>
</div>

@if (detailsOpen && selected()) {
    @if (!detailsShowNav) {
    <button class="verif-back-btn mb-3" (click)="closeDetails()">
        <img src="assets\icons\arrow.svg" alt="Back arrow" style="transform: rotate(180deg);" />
        Back
    </button>
    }
    <app-operation-submission-details
        [submission]="selected()!"
        [currentIndex]="selectedIndex"
        [total]="submissions().length"
        [showNav]="detailsShowNav"
        [canReview]="canReview"
        (approve)="openReview('approve')"
        (reject)="openReview('reject')"
        (prev)="onPrev()"
        (next)="onNext()" />
} @else {
<p-card class="mt-3">
    <app-table-component [data]="submissions()" [columns]="columns" [totalRecords]="totalRecords()" [rows]="rows"
        [first]="first" (pageChange)="onPageChange($event)" [tableName]="''" [searchControl]="searchControl"
        [showColumnSelector]="false" [showClearFilters]="false" [customFilters]="[createdDateFilter]"
        searchPlaceholder="Search plate, driver or ID..." [preserveFilterKeys]="['tab', 'status']" />
</p-card>
}

@if (reviewDialog && selected()) {
<app-review-operation-submission-form [submission]="selected()!" [action]="reviewAction"
    (reviewed)="onReviewed()" [(visibility)]="reviewDialog" />
}

<!-- ── Change Photo Status Dialog ── -->
@if (changeStatusDialog && changeStatusSubmission) {
<div class="csd-backdrop" (click)="changeStatusDialog = false" (keyup.escape)="changeStatusDialog = false" tabindex="0" role="dialog" aria-modal="true">
    <div class="csd-modal" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" tabindex="-1">
        <div class="csd-header">
            <span class="csd-title">Change Photo Status</span>
            <button type="button" class="csd-close" (click)="changeStatusDialog = false">✕</button>
        </div>
        <div class="csd-body">
            <div class="csd-ride-ref">Submission #{{ changeStatusSubmission.id }} · {{ changeStatusSubmission.plateNo }}</div>

            <div class="csd-field">
                <label class="csd-label" for="osd-status-select">Status</label>
                <p-select inputId="osd-status-select" [(ngModel)]="changeStatusValue" [options]="statusOptions"
                    optionLabel="label" optionValue="value"
                    placeholder="Select status" styleClass="w-full" />
            </div>

            <div class="csd-field">
                <label class="csd-label" for="osd-reason">Reason <span class="csd-optional">(optional, max 500 chars)</span></label>
                <textarea id="osd-reason" pTextarea [(ngModel)]="changeStatusReason"
                    placeholder="Enter reason..."
                    [maxlength]="500" rows="3" class="w-full csd-textarea"></textarea>
                <span class="csd-char-count">{{ changeStatusReason.length }} / 500</span>
            </div>

            @if (changeStatusError) {
            <div class="csd-error">{{ changeStatusError }}</div>
            }
        </div>
        <div class="csd-footer">
            <button type="button" class="csd-btn csd-btn--cancel" (click)="changeStatusDialog = false">Cancel</button>
            <button type="button" class="csd-btn csd-btn--save"
                [disabled]="!changeStatusValue || changeStatusLoading"
                (click)="submitChangeStatus()">
                @if (changeStatusLoading) { Saving... } @else { Save }
            </button>
        </div>
    </div>
</div>
}
